import styled from 'styled-components';

export const AppContainer = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
  border: 3px solid black;
  border-radius: 10px;
`;

export const TodoListUl = styled.ul`
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
`;
